import { useEffect } from 'react';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { MCPAuthModal } from 'ui-universal-auth';
import { useMcpSupportedApps } from '../../hooks/useMcpSupportedApps';
import { jsx as _jsx } from "react/jsx-runtime";
export const McpServiceComponent = ({
  metadata = {},
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted
}) => {
  var _mcpServer$clientId, _mcpServer$mcpUrl;
  const portalId = PortalIdParser.get();
  const appId = metadata.appId || 0;
  const {
    data: mcpServers,
    error
  } = useMcpSupportedApps();
  const mcpServer = mcpServers.find(({
    mcpAppId
  }) => mcpAppId === appId);
  useEffect(() => {
    if (error) {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    }
  }, [error, onAuthFailed]);
  if (!reconnectStarted || !mcpServer) {
    return null;
  }
  const onComplete = secretId => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(secretId);
  };
  const onCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  return /*#__PURE__*/_jsx(MCPAuthModal, {
    portalId: portalId,
    authenticatorId: mcpServer.authenticatorId,
    mcpServerId: mcpServer.id,
    appName: mcpServer.name,
    appId: appId
    // oAuthScope is a temporary fix for QA MCP installations
    // third party servers (e.g. visibility === 'INSTALL_REQUIRED') do not get scopes right now
    // SI created servers (e.g. visibility === 'GLOBALLY_VISIBLE') just need an empty string for now
    // still working out exactly what scopes should be passed here
    // slack thread: https://hubspot.slack.com/archives/C09PTCDDWLA/p1773869191269339?thread_ts=1773330756.488929&cid=C09PTCDDWLA
    ,
    oAuthScope: mcpServer.visibility === 'INSTALL_REQUIRED' ? undefined : '',
    mcp: {
      clientId: (_mcpServer$clientId = mcpServer.clientId) !== null && _mcpServer$clientId !== void 0 ? _mcpServer$clientId : '',
      serverUrl: (_mcpServer$mcpUrl = mcpServer.mcpUrl) !== null && _mcpServer$mcpUrl !== void 0 ? _mcpServer$mcpUrl : ''
    },
    closeModal: onCancel,
    onComplete: onComplete,
    onCancel: onCancel
  });
};